var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("LayoutLeftAuth"),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5" }, [
          _c(
            "div",
            {
              staticClass:
                "container h-full d-flex align-items-center justify-content-center flex-column"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "row d-flex flex-column text-center align-items-center"
                },
                [
                  _c("img", {
                    staticClass: "logo-mobile-auth d-sm-none",
                    attrs: { src: require("../../assets/img/blue-logo.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "reset-title" }, [
                    _vm._v("Reset link sent!")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reset-undertitle" }, [
                    _vm._v(
                      "We’ve sent a password reset link to your email. Check your inbox for further instructions."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { staticClass: "back-link", attrs: { to: "/login" } },
                    [_vm._v("Go back to login")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5982251f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5982251f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPasswordEmailSent.vue
// module id = null
// module chunks = 